import { Box, useTheme } from "@mui/material";
import { useEffect, useState } from "react";

import TabItem from "./TabItem";
import DashboardIcon from "../../../../media/images/icons/dashboard";
import GetLoadIcon from "../../../../media/images/icons/getLoadIcon";
import { useAppDispatch } from "../../../../hooks/useRedux";

import { setOpenDriverSidebar } from "../../../../redux/features/settingSlice";
import { useLocation } from "react-router-dom";
import { blueGrey } from "@mui/material/colors";
import MenuIconSVGv2 from "../../../../media/images/icons/menu-iconv2";
import UserProfileSvg from "../../../../media/images/icons/user-profile";
import PlusMiniSvg from "../../../../media/images/icons/plus-mini";

export default function BottomTabbar() {
  const theme = useTheme();
  const [, setActiveTab] = useState(0);

  const { pathname } = useLocation();

  const dispatch = useAppDispatch();

  useEffect(() => {});

  const tabItems = [
    {
      icon: (
        <PlusMiniSvg
          color={
            pathname === "/driver/check-in"
              ? theme.palette.secondary.main
              : blueGrey[400]
          }
        />
      ),
      title: "اعلام حضور",
      path: "/driver/check-in",
    },
    {
      icon: (
        <DashboardIcon
          color={
            pathname === "/driver/dashboard"
              ? theme.palette.secondary.main
              : blueGrey[400]
          }
        />
      ),
      title: "پیشخوان",
      path: "/driver/dashboard",
    },
    {
      icon: (
        <GetLoadIcon
          color={
            pathname === "/driver/get-freight"
              ? theme.palette.secondary.main
              : blueGrey[400]
          }
        />
      ),
      title: "دریافت‌بار",
      path: "/driver/get-freight",
    },
    // {
    //   icon: (
    //     <BoxOutlineIcon
    //       color={
    //         pathname === "/driver/active-cargo"
    //           ? theme.palette.secondary.main
    //           : theme.palette.info.dark
    //       }
    //     />
    //   ),
    //   title: "بارفعال",
    //   path: "/driver/active-cargo",
    // },
    {
      icon: (
        <UserProfileSvg
          color={
            pathname === "/driver/profile"
              ? theme.palette.secondary.main
              : blueGrey[400]
          }
        />
      ),
      title: "پروفایل",
      path: "/driver/profile",
    },
    // {
    //   icon: (
    //     <MedalIcon
    //       color={
    //         pathname === "/driver/karenclub"
    //           ? theme.palette.secondary.main
    //           : theme.palette.info.dark
    //       }
    //     />
    //   ),
    //   title: "کارن کلاب",
    //   path: "/driver/karenclub",
    // },
  ];

  return (
    <Box
      sx={{
        boxShadow: "8px 4px 8px 8px rgba(0,0,0,0.1)",
        position: "fixed",
        bottom: "0px",
        maxWidth: "450px",
        // zIndex: driverSidebar ? 51 : 2500,
        zIndex: 2500,
        bgcolor: "bgColor.white",
        // height: "60px",
        width: "100%",
        // border: "1px solid red",
        display: "flex",
        // alignItems: "center",
      }}
    >
      <TabItem
        handleClick={() => dispatch(setOpenDriverSidebar(true))}
        icon={<MenuIconSVGv2 size={24} color={blueGrey[400]} />}
        title={"منو"}
        path=""
      />
      {tabItems.map((item) => (
        <>
          <TabItem
            path={item.path}
            handleClick={(index) => setActiveTab(index)}
            icon={item.icon}
            title={item.title}
          />
        </>
      ))}
    </Box>
  );
}
